export default "__VITE_ASSET__2OZN1cgh__"